import ReportDetailsChart from "components/charts/e-charts/ReportDetailsChart";
import PageBreadcrumb from "components/common/PageBreadcrumb";
import ReportDetailsHeader from "components/modules/crm/report-details/ReportDetailsHeader";
import DealsReportTable, {
  dealsReportColumns,
} from "components/tables/DealsReportTable";
import ReportDetailsTable from "components/tables/ReportDetailsTable";
import { reportDetailsBreadcrumbItems } from "data/commonData";
import { dealsReportData } from "data/crm/reportsData";
import useAdvanceTable from "hooks/useAdvanceTable";
import { atom, useAtom } from "jotai";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

interface UserInfo {
  email: string;
}
const user_info = atom<UserInfo>({ email: "" });

const ReportDetails = () => {
  const [userInfo] = useAtom<UserInfo>(user_info);
  const [showDeals, setShowDeals] = useState(true);
  const isAuthorized = userInfo?.email === "michael@kairosiq.ai";

  const table = useAdvanceTable({
    data: dealsReportData,
    columns: dealsReportColumns,
    pageSize: 10,
    selection: true,
    pagination: true,
    sortable: true,
  });

  useEffect(() => {
    if (!isAuthorized) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            const backdropExists = document.getElementById("kairos-backdrop");
            if (!backdropExists) {
              setShowDeals(false);
            }
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      return () => observer.disconnect();
    }
  }, [isAuthorized]);

  return (
    <>
      {/* {(isAuthorized || showDeals) && ( */}
        <div>
          Under Maintenance
          <PageBreadcrumb items={reportDetailsBreadcrumbItems} />
          <AdvanceTableProvider {...table}>
            <div className="pb-9">
              <h2 className="mb-4">Purchasers and sellers</h2>
              <ReportDetailsHeader />
              <Row className="gy-5">
                <Col xl={5} xxl={4}>
                  <Card>
                    <Card.Body>
                      <div className="mb-5">
                        <ReportDetailsChart
                          style={{ height: "358px", width: "100%" }}
                        />
                      </div>
                      <ReportDetailsTable />
                    </Card.Body>
                  </Card>
                </Col>
                <Col xl={7} xxl={8}>
                  <DealsReportTable />
                </Col>
              </Row>
            </div>
          </AdvanceTableProvider>
        </div>
      {/* )} */}
      {/* {!isAuthorized && <Backdrop />} */}
    </>
  );
};

export default ReportDetails;
